var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPurple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87994 3.01449C5.99183 2.27155 7.29906 1.875 8.63633 1.875V2.5L8.63637 1.875C10.4295 1.87511 12.1492 2.5875 13.4172 3.85546C14.6852 5.12342 15.3975 6.84312 15.3976 8.63629V8.63633C15.3976 9.97359 15.0011 11.2808 14.2582 12.3927C13.5152 13.5046 12.4592 14.3712 11.2238 14.883C9.9883 15.3947 8.62883 15.5286 7.31726 15.2677C6.00569 15.0069 4.80094 14.3629 3.85535 13.4173C2.90976 12.4717 2.26581 11.267 2.00492 9.9554C1.74403 8.64383 1.87793 7.28435 2.38968 6.04888C2.90143 4.81341 3.76804 3.75743 4.87994 3.01449ZM8.63633 3.125C10.098 3.1251 11.4998 3.70579 12.5333 4.73935C13.5669 5.7729 14.1475 7.17466 14.1476 8.63633M8.63629 3.125C7.54626 3.12501 6.48072 3.44824 5.5744 4.05383C4.66807 4.65942 3.96167 5.52017 3.54453 6.52723C3.12739 7.5343 3.01825 8.64244 3.2309 9.71153C3.44356 10.7806 3.96846 11.7627 4.73923 12.5334C5.51 13.3042 6.49203 13.8291 7.56112 14.0418C8.63021 14.2544 9.73836 14.1453 10.7454 13.7281C11.7525 13.311 12.6132 12.6046 13.2188 11.6983C13.8244 10.7919 14.1476 9.72639 14.1476 8.63637",
    fill: "#8138DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7725 12.7725C13.0166 12.5285 13.4123 12.5285 13.6564 12.7725L17.942 17.0581C18.186 17.3022 18.186 17.6979 17.942 17.942C17.6979 18.186 17.3022 18.186 17.0581 17.942L12.7725 13.6564C12.5285 13.4123 12.5285 13.0166 12.7725 12.7725Z",
    fill: "#8138DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPurple);
export default __webpack_public_path__ + "static/media/search-purple.db4ae3db2c5ef628f855abe8de1e3f7e.svg";
export { ForwardRef as ReactComponent };